import { Button } from "@progress/kendo-react-buttons";
import GenericGrid from "pages/tables/GenericGrid";
import React, { useState } from "react";
import { useEffect } from "react";
import PropTypes from "prop-types";
import { useGetRegistreApprobationQuery } from "../../redux/api/cache";

export default function ApprobationProduitButtons(props) {
    const [campSeq, setCampSeq] = useState(props.campSeq);
    const [showDetailApprobation, setShowDetailApprobation] = useState(false);
    const { data } = useGetRegistreApprobationQuery(campSeq);

    useEffect(() => {
        setCampSeq(props.campSeq);
    }, [props.campSeq]);

    return <><div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}><Button className={showDetailApprobation ? 'greyButton' : 'blueButton'} title='Registre des approbations' style={{ margin: '10px' }} onClick={() => { setShowDetailApprobation(!showDetailApprobation); }}>Approbation</Button></div>

        {showDetailApprobation && data && data.data && (
            <>
                <h3 style={{ margin: '10px', color: '#007bff' }}>Registre des approbations</h3>
                <GenericGrid
                    autoSize={true}
                    rowClicked={() => { }}
                    definition={data.meta.definition}
                    data={data.data}
                ></GenericGrid>
            </>
        )}</>;
}

ApprobationProduitButtons.propTypes = {
    campSeq: PropTypes.any.isRequired
};